import React, {Component, createRef, Fragment} from 'react';

import '../../../chat.css';
import Localization from '../../../config/localization/Localization'
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Icon from "@material-ui/core/Icon";
import MoodICon from "@material-ui/icons/Mood";
import Popover from "@material-ui/core/Popover";
import 'emoji-mart/css/emoji-mart.css'
import { Picker } from 'emoji-mart'
import { isMobile } from "react-device-detect";
import {getLocalizationLanguageCode} from "../../../util/localization";
import Button from "@material-ui/core/Button";
import LayoutTypeEnum from '../../../config/constants/LayoutTypeEnum';
import ChatAttachment from '../chatAttachment/ChatAttachment';
import { Chat } from '@material-ui/icons';


/**
 * Class for the chat message input field.
 */
class ChatInputField extends Component {
    constructor(props) {
        super(props);
        this.textareaRef = React.createRef();
        this.wrapperRef = React.createRef();
        this.state = {
            anchorEl: null,
            selectionStart:0,
            selectionEnd:0,
            emojiIsHovered : false,
            isExpanded: false,
            
        }
    }

/*     componentDidMount() {
        // Attach click event listener to the document
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        // Remove click event listener from the document
        document.removeEventListener('mousedown', this.handleClickOutside);
    } */


    handleEmojiHover=()=>{
        this.setState({
            emojiIsHovered: !this.state.emojiIsHovered
        });
    }


    openEmojiPopover = () => {
        this.setState({anchorEl: this.btnEl});

    };

    closeEmojiPopover = () => {
        this.setState({anchorEl: null});
    };


    /**
     * Handles keyboard input in the chat input field.
     */
    handleInputKeyPress = (e) => {
        if (e.key === 'Enter') {
            
            if (e.shiftKey && this.props.chatConfig.layoutMode === LayoutTypeEnum.chatBot) {
                return;
            }
            
            e.preventDefault();
            return this.props.sendMessage(true);

        }
       /* else if(e.key === 'ArrowUp'){

            e.preventDefault();
            this.props.onInputUpKeyStroke();
        }  else if(e.key === 'ArrowDown'){
            e.preventDefault();
            this.props.onInputDownKeyStroke();
        }*/
    };


    handleInputOnClick = (e) => {

        if (typeof(this.input)==='object'&&this.input!==null) {
            const selectionStart = this.input.selectionStart
            const selectionEnd = this.input.selectionEnd
            this.setState({
                selectionStart: selectionStart,
                selectionEnd: selectionEnd,
            })

            if(this.props.chatConfig.layoutMode == LayoutTypeEnum.searchBot ){

                if(this.props.message.length == 0 && (this.props.speechBubbleList == null|| this.props.speechBubbleList.length == 0))
                {
                    this.props.reEnableMostAskedQuestions()
                }
                this.setState({isExpanded: true})
                this.props.setShowSearchBotChatField(true);
            }
        } 
    }

    handleClickOutside = (event) => {
        // Check if the click is outside the wrapper containing the textarea
        if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
            // Perform the desired action for clicks outside
            console.log('Clicked outside the textarea');
            // Example action: Hide an element or trigger a function
            const element = document.querySelector('#search-bot-chat-field-content-container');
            if (element) {
                element.style.display = 'none'; // Change display or other styles as needed
            }
        }
    };

    /**
     * Handles onchange input in the chat input field.
     */
    handleInputOnChange = (e) => {
        
        if (e.target.value === '' || this.props.message === '') {
            const isWriting = this.props.message === '';
            this.props.sendUserIsWriting(isWriting);
        }

        if (typeof(this.input)==='object'&&this.input!==null) {
            const selectionStart = this.input.selectionStart
            if (typeof(selectionStart)==='number') {
                this.setState({
                  selectionStart:selectionStart,
                    selectionEnd:selectionStart,
                })
            }
        }

        this.props.handleMessageChanges(e.target.value);
    };


    /**
     * Handles emoji in the chat input field.
     */
    addEmoji = (emoji) => {

        const emojiString =  (this.props.message ? ' ': '') + emoji.native;

        const message =   this.props.message.substr(0, this.state.selectionStart) + emojiString + this.props.message.substr(this.state.selectionStart);

        this.setState({anchorEl: null});

        this.props.handleMessageChanges(message);
    };

    render() {

        const localizationCode = getLocalizationLanguageCode(this.props.language ? this.props.language.languageCode : null)

        return (
            <Fragment>
            <div id={'chat-input-field-container'}>
            {(this.props.chatConfig.layoutMode === LayoutTypeEnum.searchBot) ? (
                <div
                    style={{
                        fontSize: '2rem',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'left',
                        paddingRight: '10px',
                        color:'darkgray'
                    }}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <circle cx="11" cy="11" r="8"></circle>
                        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                    </svg>
                </div>
            ) : null}
                <TextareaAutosize  tabIndex="1" id={'chat-input-field'} value={this.props.message}
                                    placeholder={
                                        this.props.language
                                        ? this.props.fileUploadedText
                                          ? Localization[localizationCode]['chatInputField.chatInputPlaceholderFileUploadMode']
                                          : this.props.chatAgentMode
                                          ? Localization[localizationCode]['chatInputField.chatInputPlaceholderAgentMode']
                                          : this.props.chatInputText && this.props.chatInputText !== ''
                                          ? this.props.chatInputText
                                          : Localization[localizationCode]['chatInputField.chatInputPlaceholder']
                                        : ''
                                      }
                                   maxLength={this.props.chatInputMax? this.props.chatInputMax: '256'} onChange={this.handleInputOnChange} onClick={this.handleInputOnClick}  autoComplete={'off'} autoFocus
                                   ref={el=>this.input=el}
                                   onKeyDown={this.handleInputKeyPress}
                                   maxRows={ this.props.chatConfig && this.props.chatConfig.layoutMode === LayoutTypeEnum.searchBot ? 1 : 1000 }
                                   style={{font: this.props.chatConfig ? this.props.chatConfig.font : null}}/>

            </div>
                {this.props.chatConfig && isMobile === false && (this.props.chatConfig.enableEmoji || this.props.chatAgentMode) ?
                    <div id={'chat-input-emoji-container'}>

                        <Icon  tabIndex="2" id={'chat-input-menu-btn'}  onClick={this.openEmojiPopover} ref={(el) => {this.btnEl = el;}}>
                            <MoodICon style={{fill: this.props.chatConfig && this.state.emojiIsHovered == true ? this.props.chatConfig.inputButtonsFocusedColor : '#a3a3a8'}}   onMouseEnter={this.handleEmojiHover} onMouseLeave={this.handleEmojiHover}  /></Icon>

                        <Popover
                            id="mouse-over-popover"
                            open={Boolean(this.state.anchorEl)}
                            anchorEl={this.state.anchorEl}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            onClose={this.closeEmojiPopover}
                            disableRestoreFocus
                        >
                            <Picker showPreview="false"  showSkinTones="false" showSkinTones="false" skin={5} onSelect= {this.addEmoji} include={['people']}  i18n={{ search: 'Search',
                                clear: 'Clear', // Accessible label on "clear" button
                                notfound: 'No Emoji Found',
                                skintext: 'Choose your default skin tone',
                                categories: {
                                    search: 'Search Results',
                                    recent: 'Frequently Used',
                                    smileys: 'Smileys & Emotion',
                                    people: 'People & Body',
                                    nature: 'Animals & Nature',
                                    foods: 'Food & Drink',
                                    activity: 'Activity',
                                    places: 'Travel & Places',
                                    objects: 'Objects',
                                    symbols: 'Symbols',
                                    flags: 'Flags',
                                    custom: 'Custom',
                                },
                                categorieslabel: 'Emoji categories', // Accessible title for the list of categories
                                skintones: {
                                    1: 'Default Skin Tone',
                                    2: 'Light Skin Tone',
                                    3: 'Medium-Light Skin Tone',
                                    4: 'Medium Skin Tone',
                                    5: 'Medium-Dark Skin Tone',
                                    6: 'Dark Skin Tone',
                                }, }} emojiTooltip="false" set='apple' />
                        </Popover>


                    </div> : null}

                {this.props.showStopMessage ?
                    <div id={'chat-input-field-stop-container'} onClick={this.props.stopMessage}>
                        <svg xmlns="http://www.w3.org/2000/svg" height={25} width={25} style={{fill: "darkgray"}}
                             viewBox="0 0 297 297">
                            <path d="M148.5,0C66.486,0,0,66.486,0,148.5S66.486,297,148.5,297S297,230.514,297,148.5S230.514,0,148.5,0z M213.292,190.121
                            c0,12.912-10.467,23.379-23.378,23.379H106.67c-12.911,0-23.378-10.467-23.378-23.379v-83.242c0-12.912,10.467-23.379,23.378-23.379
                            h83.244c12.911,0,23.378,10.467,23.378,23.379V190.121z"/>
                        </svg>
                    </div>: null
                }

                {(this.props.chatConfig.layoutMode === LayoutTypeEnum.searchBot && this.props.message) ? (<Button
                    onClick={() => this.props.handleResetChatInput()}
                    style={{
                        fontSize: '2rem', // Makes the × symbol larger
                        fontWeight: 'normal', // Ensures the × is bold and visible
                        textAlign: 'center', // Centers the text inside the button
                        width: '30px', // Adjusts the button width (customize as needed)
                        height: '30px', // Adjusts the button height (customize as needed)
                        lineHeight: '30px', // Aligns the × vertically
                        border: 'none', // Removes any default borders
                        backgroundColor: 'transparent', // Optional: Makes the button background transparent
                        cursor: 'pointer', // Adds a pointer cursor for better UX
                        minWidth : '30px',
                        color:'darkgray'
                    }}
                >
                    &times;
                </Button>): null}
                {this.props.fileUploadedText == false || this.props.message ?
                    <Button title={Localization[getLocalizationLanguageCode(this.props.language ? this.props.language.languageCode : null)]['chatInput..title.send']} tabIndex="3" id={'chat-input-field-send-arrow-container'} onClick={()=>this.props.sendMessage(true)}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 535.5 535.5" style={{fill: this.props.chatConfig && this.props.chatConfig.inputButtonsFocusedColor }}    >
                            <g>
                                <polygon
                                    points="0,497.25 535.5,267.75 0,38.25 0,216.75 382.5,267.75 0,318.75"></polygon>
                            </g>
                        </svg>
                    </Button> : null }
            </Fragment>


    );
    }
}

export default ChatInputField;